import {isCell} from '@packages/utilities/elementTypeUtils';
import {selectSelectedElement} from '@packages/utilities/platform-selectors';
import type {UiNodeStateType} from '@packages/systems/core/records/UiNodeState';
import type {DesignerStateType} from '@packages/systems/core/records/DesignerState';

/**
 * Checks if selectedElement is a Layout Cell type
 */
const selectedElementIsLayoutCell = (state: {
  UiNodeStore: UiNodeStateType;
  DesignerStore: DesignerStateType;
}): boolean | null => {
  const selectedElement = selectSelectedElement(state);
  return selectedElement && isCell(selectedElement);
};

export default selectedElementIsLayoutCell;
